import React from "react";
import { VMProvider } from "../../../commons/base/providers/provider";
import AdjustmentFormsToVendorViewModel from "./view_models/adjustment_forms_to_vendor_view_model";
import Scaffold from "../../../commons/scaffold/scaffold";
import AdjustmentFormsToVendorTableWidget from "./widgets/adjustment_forms_to_vendor_table_widget";
import AdjustmentFormsToVendorFilterWidget from "./widgets/adjustment_forms_to_vendor_filter_widget";
import AdjustmentFormsToVendorModalWidget from "./widgets/adjustment_forms_to_vendor_modal_widget";

export default class AdjustmentFormsToVendorScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new AdjustmentFormsToVendorViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundType="semi_transparent"
                        showSnackbar={vm.showSnackbar}
                        showErrorView={vm.showErrorView}
                    >
                        <div className=" bg-slate-500 overflow-x-auto min-h-screen p-5 mt-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold flex-grow m-5">
                                Adjustment Form Pengiriman ke Vendor
                            </h1>

                            {vm.isShowModal && (
                                <AdjustmentFormsToVendorModalWidget />
                            )}
                            <AdjustmentFormsToVendorFilterWidget />
                            <AdjustmentFormsToVendorTableWidget />
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
